import React from 'react';

const AboutAIAnytime = () => {
  return (
    <section className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-outfit font-800 text-white mb-6">
            AI Anytime — A grassroots AI learning community
          </h2>

          <p className="text-lg font-outfit font-600 text-gray-300 mb-12 leading-relaxed">
            AI Anytime is a community initiative under <span className="text-crimson font-800">Sankhyantra Foundation</span>, 
            focused on practical AI learning, open research, and collaborative initiatives such as 
            <span className="text-white font-800"> AI Day</span> and <span className="text-white font-800">AI Gramshala</span>.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <a 
              href="https://aianytime.net/" 
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary w-full sm:w-auto text-center"
            >
              Visit Community
            </a>
            <a 
              href="https://www.youtube.com/@AIAnytime" 
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary-light w-full sm:w-auto text-center flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
              Watch on YouTube
            </a>
            <a 
              href="https://www.linkedin.com/company/ai-anytime/?viewAsMember=true" 
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary-light w-full sm:w-auto text-center flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              Join our Network
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutAIAnytime;
